/**
 * Managers Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import Swal from "sweetalert2";
import {store} from "../../store";
// States
const state = {
    managers: [],
    manager: {}
};

// Getters
const getters = {
    managers: state => {
        return state.managers
    },

    manager: state => {
        return state.manager
    }
};

// Actions
const actions = {
    getManagers(context, payload) {
        function successCallback(response) {
            context.commit('getManagersHandler', { managers: response.data.gestionnaires });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Manager.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getManager(context, payload) {
        function successCallback(response) {
            context.commit('getManagerHandler', { manager: response.data.gestionnaire });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Manager.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createManager(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('message')){
                Swal.fire(
                    response.data.message,
                    '',
                    'warning'
                );
            }
            router.push({ name: 'manager', params: { manager: response.data.gestionnaire.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Manager.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateManager(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            store.dispatch('findAndRemove', {name: 'manager' });
            router.push({ name: 'manager', params: { manager: response.data.gestionnaire.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Manager.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteManager(context, payload) {
        function successCallback(response) {
            context.commit('deleteManagerHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Manager.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getManagersHandler(state, { managers }) {
        // Update managers state
        state.managers = managers;
    },

    getManagerHandler(state, { manager }) {
        // Update manager state
        state.manager = manager;
    },

    deleteManagerHandler(state, { index, successMessage }) {
        let i = state.managers.findIndex(manager => manager.slug === index);

        if (~i) {
            state.managers.splice(i, 1);

            router.push({ name: 'managers' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}